import React from 'react'
import { useParams } from 'react-router-dom'
import AUserSidebar from '../../components/AdminProfile/AUserSidebar'
import AAccountSettings from '../../components/AdminProfile/AAccountSettings'
import './AUserProfile.css'
import AUserAddress from '../../components/AdminProfile/AUserAddress'
import ALegalNotice from '../../components/AdminProfile/ALegalNotice'
import OrderScreen from '../../screens/OrderScreen'
import Footer from '../../../features/footer/Footer';

const AUserProfile = () => {
    const {pk,activepage} = useParams()
  return (
    <div className='mt-28'>
    <div className='userprofile'>
         <div className='userprofilein'>
            <div className='left'>
              <AUserSidebar activepage={activepage}/>
            </div>
              {activepage === `/admin/AccountSettings/${pk}` && <AAccountSettings/>}
              {activepage === `/admin/orders/${pk}` && <OrderScreen/>}
              {activepage === '/user/address' && <AUserAddress/>}
              {activepage === 'legalnotice' && <ALegalNotice/>}
         </div>
         <Footer className='mb-1'></Footer>
        </div>
    </div>
  )
}

export default AUserProfile
